'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _AbstractReactComponent = require('../AbstractReactComponent');

var _AbstractReactComponent2 = _interopRequireDefault(_AbstractReactComponent);

require('./DetailValue.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Komponenta pro label a hodnotu pro použití na detailech.
 * Pokud je obsahem řetězec (text) a ten obsahuje \n, jsou pro render použity <span> oddělené pomocí <br/>.
 */
// --
var DetailValue = function (_AbstractReactCompone) {
    (0, _inherits3.default)(DetailValue, _AbstractReactCompone);

    function DetailValue() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, DetailValue);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DetailValue.__proto__ || (0, _getPrototypeOf2.default)(DetailValue)).call.apply(_ref, [this].concat(args))), _this), _this.hasChildren = function () {
            var children = _this.props.children;


            if (typeof children === "number") {
                return true;
            }

            if (children) {
                if (Array.isArray(children)) {
                    var hasNotNull = false;
                    for (var a = 0; a < children.length; a++) {
                        if (typeof children[a] === "number" || children[a]) {
                            hasNotNull = true;
                            break;
                        }
                    }
                    return hasNotNull;
                } else {
                    return true;
                }
            } else {
                return false;
            }
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    /**
     * Má nějaké potomky, které se budou renderovat?
     * @return {boolean} true, pokud má nějaké potomky, které se budou renderovat
     */


    (0, _createClass3.default)(DetailValue, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                title = _props.title,
                horizontal = _props.horizontal,
                valueTitle = _props.valueTitle,
                textOverflow = _props.textOverflow,
                emptyValue = _props.emptyValue,
                label = _props.label,
                children = _props.children,
                className = _props.className;


            var wrapperClassNames = (0, _classnames2.default)(className, {
                "text-overflow": textOverflow,
                "detail-value-horizontal": horizontal
            });
            var content = void 0;
            if (this.hasChildren()) {
                if (typeof children === "string") {
                    content = children.split('\n').map(function (item, key) {
                        return _react2.default.createElement(
                            'span',
                            { key: key },
                            item,
                            _react2.default.createElement('br', null)
                        );
                    });
                } else {
                    content = children;
                }
            } else {
                content = emptyValue;
            }

            return _react2.default.createElement(
                'dl',
                { className: wrapperClassNames, title: title },
                label && _react2.default.createElement(
                    'dt',
                    null,
                    label
                ),
                content !== null && _react2.default.createElement(
                    'dd',
                    { title: valueTitle },
                    content
                )
            );
        }
    }]);
    return DetailValue;
}(_AbstractReactComponent2.default);

DetailValue.propTypes = {
    label: _react2.default.PropTypes.oneOfType([_react2.default.PropTypes.node]), // label hodnoty
    emptyValue: _react2.default.PropTypes.string, // co zobrazovat když hodnota je prázdná, implicitně "-", pokud je null a má práznou hodnotu, vůbec se nerenderuje dd tag, pokud je např. "", dd se renderuje
    textOverflow: _react2.default.PropTypes.bool, // pokud je true, je na hodnotu použit styl pro oříznutí velkých textů na tři tečky
    valueTitle: _react2.default.PropTypes.string, // title na value
    horizontal: _react2.default.PropTypes.bool, // pokud je true, je zobrazováno horizontálně, standardn2 false
    title: _react2.default.PropTypes.string // title na vše
};
DetailValue.defaultProps = {
    emptyValue: "-"
};
exports.default = DetailValue;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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